<template>
  <div class="d-flex flex-column">
    <subnav :links="subnav" heading="Денежный поток"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Денежный поток'},
    data: () => ({
      subnav: [
        {
          text: 'Пополнения и возвраты',
          to: '/billing/cash-flow/refills-and-refunds',
          exact: true,
          permission: 'web_billing_cash_flow',
        },
        {
          text: 'Списания',
          to: '/billing/cash-flow/write-offs',
          permission: 'web_billing_cash_flow',
        },
        {
          text: 'График',
          to: '/billing/cash-flow/history',
          permission: 'web_billing_cash_flow',
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/billing/cash-flow/index.vue